import React from 'react';

type DangerActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  fullWidth?: boolean;
};

const DangerActionButton: React.FC<DangerActionButtonProps> = ({
  children,
  className = '',
  fullWidth = false,
  type = 'button',
  ...props
}) => (
  <button
    type={type}
    className={`inline-flex items-center justify-center gap-2 rounded-full border border-red-400/20 bg-red-500/10 px-5 py-3 text-sm font-semibold uppercase tracking-[0.2em] text-red-100 transition hover:-translate-y-0.5 hover:bg-red-500/18 disabled:cursor-not-allowed disabled:opacity-50 ${fullWidth ? 'w-full' : ''} ${className}`.trim()}
    {...props}
  >
    {children}
  </button>
);

export default DangerActionButton;

